import { useState } from 'react';

const defaultPageSize = 10;

export const usePagination = () => {
  const [current, setCurrent] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);
  const [total, setTotal] = useState<number>(0);

  const next = () => {
    setCurrent(current + 1);
  };

  const reset = () => {
    setCurrent(1);
    setPageSize(defaultPageSize);
    setTotal(0);
  };

  const setPage = (pageNum: number) => {
    setCurrent(pageNum);
  };

  return {
    current,
    pageSize,
    total,
    start: current * pageSize - pageSize,
    end: current * pageSize,
    display: total > pageSize,
    setTotal,
    setPageSize,
    next,
    setCurrent,
    setPage,
    reset,
  };
};
